<template>
    <div class="HtmlEditorToolbarColor">
      <div
        v-for="color in colors"
        :key="color"
        @click="selectColor(color)"
        class="HtmlEditorToolbarColor__box"
        :style="{ backgroundColor: color }"
      >
        <span v-if="selectedColor === color" class="HtmlEditorToolbarColor__box_checkmark" :style="selectedColor == '#FFFFFF' ? 'color: black;' : 'color: white;'">✔</span>
      </div>
    </div>
  </template>

  <script>
  export default {
    props: {
      selectedColor: {
        type: String,
        required: false,
        default: '#000000',
      },
    },
    data() {
      return {
        colors: ['#FF0000', '#00FF00', '#0000FF', '#FFFF00', '#FFA500', '#FFC0CB', '#800080', '#808080', '#A52A2A', '#808000', '#40E0D0', '#00FFFF', '#FF00FF', '#C0C0C0', '#FFD700', '#E6E6FA', '#000080', '#006400', '#000000', '#FFFFFF']
      };
    },
    methods: {
      selectColor(color) {
        this.$emit('color', color);
      }
    }
  };
  </script>

  <style lang="scss">
  .HtmlEditorToolbarColor {
    width: 180px;
    display: flex;
    flex-wrap:wrap;
    background: #fff;
    &__box {
      margin: 5px;
      width: 25px;
      height: 25px;
      display: flex;
      cursor: pointer;
      align-items: center;
      border: 1px solid #ccc;
      justify-content: center;
    }
  }
  </style>